import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from 'src/app/shared/shared.module'
import {
	MAT_MOMENT_DATE_ADAPTER_OPTIONS,
	MatMomentDateModule,
} from '@angular/material-moment-adapter'
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { ProductsRoutingModule } from './products-routing.module'
import { ProductsListComponent } from './pages/products-list/products-list.component'
import { ProductsFilterComponent } from './components/products-filter/products-filter.component'
import { ProductsTableComponent } from './components/products-table/products-table.component'
import { ProductDetailsComponent } from './pages/product-details/product-details.component'
import { ProductsSliderComponent } from './components/products-slider/products-slider.component'
import { ProductCompareModeComponent } from './components/product-compare-mode/product-compare-mode.component'
import { MatSliderModule } from '@angular/material/slider'
import { SliderCropperComponent } from './components/slider-cropper/slider-product-cropper.component'
import { SliderUploaderComponent } from './components/slider-uploader/product-slider-uploader.component'
import { ProductVarianceComponent } from './components/product-variance/product-variance.component'
import { NgxEditorModule } from 'ngx-editor'
import { EditProductVariantComponent } from './components/edit-product-variant/edit-product-variant.component'
import { ProductPromocodeComponent } from './pages/product-promocode/add-product-promocode.component'
import { ProductPromoCodeListComponent } from './pages/product-promocode-list/product-promocode-list.component'
import { ProductPromoCodeTableComponent } from './components/product-promocode-table/product-promocode-table.component'
import { ProductPromoCodeFilterComponent } from './components/product-promocode-filter/product-promo-code-filter.component'
import { ViewProductPromocodeComponent } from './pages/view-product-promocode/view-product-promocode.component'
import { EditProductPromocodeComponent } from './pages/edit-product-promocode/edit-product-promocode.component'
import { NgxColorsModule } from 'ngx-colors'

@NgModule({
	declarations: [
		ProductsListComponent,
		ProductsTableComponent,
		ProductsFilterComponent,
		ProductDetailsComponent,
		ProductsSliderComponent,
		ProductCompareModeComponent,
		SliderUploaderComponent,
		SliderCropperComponent,
		ProductVarianceComponent,
		EditProductVariantComponent,
		ProductPromocodeComponent,
		ProductPromoCodeListComponent,
		ProductPromoCodeTableComponent,
		ProductPromoCodeFilterComponent,
		ViewProductPromocodeComponent,
		EditProductPromocodeComponent,
	],
	imports: [
		CommonModule,
		ProductsRoutingModule,
		SharedModule,
		MatSliderModule,
		NgxEditorModule,
		MatMomentDateModule,
		NgxColorsModule,
	],
	providers: [
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
		{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
	],
})
export class ProductsModule {}
